import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3dca3680"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "home"
};
const _hoisted_2 = {
  class: "pay w-full overflow-y-auto"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = {
  class: "flex items-center"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("b", {
  class: "block"
}, null, -1));
const _hoisted_6 = {
  class: "title relative"
};
const _hoisted_7 = ["for"];
const _hoisted_8 = ["name", "id"];
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1));
const _hoisted_10 = {
  class: "btns flex flex-col justify-center items-center"
};
const _hoisted_11 = {
  class: "w-full relative"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "paypal-button"
}, null, -1));
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "email",
  href: "mailto: feedbackwithlily@gmail.com"
}, "Support：feedbackwithlily@gmail.com", -1));
import CommonHeader from './components/CommonHeader.vue';
import Banner from './components/Banner.vue';
import { getInfo } from "@/utils/bridge";
import usePaypal from "@/usePaypal";
import LoadingLayer from './components/Loading';
export default {
  __name: 'App',
  setup(__props) {
    const iap = reactive({});
    const customProps = reactive({});
    const amount = ref(0);
    const price = ref('');
    const orderId = ref('');
    const payMethod = ref('Paypal');
    const currencyCode = ref('');
    const paymentMethodList = computed(() => {
      const payMethods = [
      // {
      //   name:'nativePay',
      //   title: 'Pay via Google Pay',
      //   text: 'Pay within the Google',
      //   textColor: '#000'
      // },
      {
        name: 'Paypal',
        title: 'Paypal',
        text: 'Guaranteed by Paypal',
        textColor: '#000'
      }];
      return payMethods;
    });
    const {
      renderPaypal,
      paypalCanClick
    } = usePaypal(amount, currencyCode, orderId);
    const handleEvent = ({
      data,
      source,
      origin
    }) => {
      if (data && typeof data === 'object' && data.functions) {
        const {
          belong,
          functions,
          params
        } = data;
        console.log('subPage received message', data, ' from ', origin);
        if (belong === 'ym-assembled') {
          switch (functions) {
            case 'info':
              console.log('iframe received', params);
              amount.value = params.amount;
              price.value = params.price;
              orderId.value = params.orderId;
              currencyCode.value = params.currency;
              if (document.querySelector('#paypal-button').innerHTML.length === 0) {
                renderPaypal('#paypal-button');
              }
              break;
            default:
          }
        }
      }
    };
    window.addEventListener('message', handleEvent);
    onMounted(() => {
      getInfo();
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(CommonHeader), _createVNode(Banner, {
        price: _unref(price)
      }, null, 8, ["price"]), _createElementVNode("ul", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(paymentMethodList), item => {
        return _openBlock(), _createElementBlock("li", {
          key: item.name,
          class: _normalizeClass(["flex items-center justify-between border-box pointer", item.name]),
          onClick: $event => payMethod.value = item.name
        }, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("div", _hoisted_6, [_createElementVNode("p", null, _toDisplayString(item.title), 1), _createElementVNode("p", {
          style: _normalizeStyle({
            color: item.textColor
          })
        }, _toDisplayString(item.text), 5)])]), _createElementVNode("label", {
          for: item.name,
          class: _normalizeClass(["block relative", _unref(payMethod) === item.name ? 'choosed' : ''])
        }, [_createElementVNode("input", {
          type: "radio",
          name: item.name,
          id: item.name
        }, null, 8, _hoisted_8), _hoisted_9], 10, _hoisted_7)], 10, _hoisted_3);
      }), 128)), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [!_unref(paypalCanClick) ? (_openBlock(), _createBlock(_unref(LoadingLayer), {
        key: 0
      })) : _createCommentVNode("", true), _hoisted_12]), _hoisted_13])])]);
    };
  }
};